export default __webpack_public_path__ + "static/media/whatsapp.4005d5af.png";